var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('screen-error',{attrs:{"route":{ name: 'Home' },"label":_vm.$t('error.button.back')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }